import { BaseEntryScope } from '#packages/apilib';
import { EditorAPIKey, StageContextApiKey } from '#packages/apis';

export class CompPointersScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  stageContextApi = this.useDependency(StageContextApiKey);
}
